const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_OaN4IKWnP',
      userPoolRegion: 'us-east-1',
      userPoolClientId: '1p644c5qpbprshs4a7qd08sqff',
      loginWith: {
        oauth: {
          domain: 'us-east-1oan4ikwnp.auth.us-east-1.amazoncognito.com',
          scopes: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: ['https://lotus.grieversandfriends.com/', 'https://lotus.grieversandfriends.com/test', 'http://localhost:3000/'],
          redirectSignOut: ["https://grieversandfriends.com/", 'https://lotus.grieversandfriends.com/', 'https://lotus.grieversandfriends.com/test', 'http://localhost:3000/'],
          responseType: 'code',
        },
        username: 'true',
        email: 'false', // Optional
        phone: 'false', // Optional
      }
    }
  }
}

export default awsConfig;